import {createRouter, createWebHistory} from 'vue-router'
import Home from "@/views/Home";
import TheContainer from "@/components/TheContainer";
import Login from "@/views/Login";

import AddItem from "@/views/Items/AddItem";
import Genres from "@/views/OtherData/Genres";
import Country from "@/views/OtherData/Country";
import Categories from "@/views/OtherData/Categories";
import CastPersons from "@/views/OtherData/CastPersons";
import CastCategories from "@/views/OtherData/CastCategories";
import ItemsList from "@/views/Items/ItemsList";
import Seasons from "@/views/Items/Seasons";
import Episode from "@/views/Items/Episode";
import EpisodeSource from "@/views/Items/EpisodeSource";
import EpisodeSubtitle from "@/views/Items/EpisodeSubtitle";
import Languages from "@/views/OtherData/Languages";
import MovieSubtitle from "@/views/Items/MovieSubtitle";
import MovieSource from "@/views/Items/MovieSource";
import VideoAdvertises from "@/views/OtherData/VideoAdvertises";
import HomeDesign from "@/views/OtherData/HomeDesign";
import CommentList from "@/views/comments/CommentList";
import ReportList from "@/views/reports/ReportList";
import ComplaintList from "@/views/complaints/ComplaintList";
import ItemPersons from "@/views/Items/ItemPersons";
import ItemCertificate from "@/views/Items/ItemCertificate";
import AgeGrades from "@/views/OtherData/AgeGrades";

const routes = [
    {
        path: '/',
        redirect: '/home',
        name: "سین نت",
        meta: {
            requiresAuth: true
        },
        component: TheContainer,
        children: [
            {
                path: '/home',
                name: "Home",
                meta: {
                    requiresAuth: true,
                },
                component: Home,
                // component: Dashboard,
            }, {
                path: '/add-item',
                name: "Add Item",
                meta: {
                    requiresAuth: true,
                },
                component: AddItem,
                // component: Dashboard,
            }, {
                path: '/edit-item/:id',
                name: "Edit Item",
                meta: {
                    requiresAuth: true,
                },
                component: AddItem,
                // component: Dashboard,
            }, {
                path: '/seasons/:id',
                name: "Seasons",
                meta: {
                    requiresAuth: true,
                },
                component: Seasons,
                // component: Dashboard,
            }, {
                path: '/episode/:season_id/:episode_id',
                name: "Episode",
                meta: {
                    requiresAuth: true,
                },
                component: Episode,
                // component: Dashboard,
            }, {
                path: '/episode_sources/:episode_id',
                name: "EpisodeSource",
                meta: {
                    requiresAuth: true,
                },
                component: EpisodeSource,
                // component: Dashboard,
            }, {
                path: '/episode_subtitle/:episode_id',
                name: "EpisodeSubtitle",
                meta: {
                    requiresAuth: true,
                },
                component: EpisodeSubtitle,
                // component: Dashboard,
            }, {
                path: '/movie_subtitle/:movie_id',
                name: "MovieSubtitle",
                meta: {
                    requiresAuth: true,
                },
                component: MovieSubtitle,
                // component: Dashboard,
            }, {
                path: '/movie_sources/:movie_id',
                name: "MovieSource",
                meta: {
                    requiresAuth: true,
                },
                component: MovieSource,
                // component: Dashboard,
            },
            {
                path: '/item-persons/:movie_id',
                name: "ItemPersons",
                meta: {
                    requiresAuth: true,
                },
                component: ItemPersons,
                // component: Dashboard,
            },
            {
                path: '/item-certificate/:movie_id',
                name: "ItemCertificate",
                meta: {
                    requiresAuth: true,
                },
                component: ItemCertificate,
                // component: Dashboard,
            },


            {
                path: '/items-list',
                name: "ItemsList",
                meta: {
                    requiresAuth: true,
                },
                component: ItemsList,
                // component: Dashboard,
            }, {
                path: '/genres',
                name: "Genres",
                meta: {
                    requiresAuth: true,
                },
                component: Genres,
                // component: Dashboard,
            }, {
                path: '/age-grade',
                name: "AgeGrades",
                meta: {
                    requiresAuth: true,
                },
                component: AgeGrades,
                // component: Dashboard,
            },
            {
                path: '/countries',
                name: "Country",
                meta: {
                    requiresAuth: true,
                },
                component: Country,
                // component: Dashboard,
            },
            {
                path: '/languages',
                name: "Languages",
                meta: {
                    requiresAuth: true,
                },
                component: Languages,
                // component: Dashboard,
            },
            {
                path: '/cast-persons',
                name: "CastPersons",
                meta: {
                    requiresAuth: true,
                },
                component: CastPersons,
                // component: Dashboard,
            },
            {
                path: '/cast-categories',
                name: "CastCategories",
                meta: {
                    requiresAuth: true,
                },
                component: CastCategories,
                // component: Dashboard,
            },
            {
                path: '/categories/:parent_id',
                name: "Categories",
                meta: {
                    requiresAuth: true,
                },
                component: Categories,
                // component: Dashboard,
            },

            {
                path: '/video-advertises',
                name: "VideoAdvertises",
                meta: {
                    requiresAuth: true,
                },
                component: VideoAdvertises,
                // component: Dashboard,
            },
            {
                path: '/home-design',
                name: "HomeDesign",
                meta: {
                    requiresAuth: true,
                },
                component: HomeDesign,
                // component: Dashboard,
            },
            {
                path: '/comments',
                name: "CommentList",
                meta: {
                    requiresAuth: true,
                },
                component: CommentList,
                // component: Dashboard,
            },
            {
                path: '/poster_reports',
                name: "ReportList",
                meta: {
                    requiresAuth: true,
                },
                component: ReportList,
                // component: Dashboard,
            },
            {
                path: '/complaints',
                name: "ComplaintList",
                meta: {
                    requiresAuth: true,
                },
                component: ComplaintList,
                // component: Dashboard,
            },
            {
                path: '/uploader',
                name: "uploader",
                meta: {
                    requiresAuth: true,
                },
                component: Uploader,
                // component: Dashboard,
            },
            {
                path: '/payments',
                name: "payments",
                meta: {
                    requiresAuth: true,
                },
                component: Payments,
                // component: Dashboard,
            },

            {
                path: '/user_videos',
                name: "UserVideos",
                meta: {
                    requiresAuth: true,
                },
                component: UserVideos,
                // component: Dashboard,
            },
            {
                path: '/news',
                name: "News",
                meta: {
                    requiresAuth: true,
                },
                children:[
                    {
                        path: 'cats/:cat_id',
                        name: "Cat News",
                        meta: {
                            requiresAuth: true,
                        },
                        component: BlogCategoryList,
                    },
                    {
                        path: 'add',
                        name: "Add News",
                        meta: {
                            requiresAuth: true,
                        },
                        component: BlogAddNews,
                    },
                    {
                        path: 'edit/:post_id',
                        name: "Edit News",
                        meta: {
                            requiresAuth: true,
                        },
                        component: BlogAddNews,
                    },
                    {  path: 'list',
                        name: "news List",
                        meta: {
                            requiresAuth: true,
                        },
                        component: BlogNewsList,
                    },
                    {  path: 'comments',
                        name: "comments List",
                        meta: {
                            requiresAuth: true,
                        },
                        component: BlogCommentList,
                    }
                ],
                // component: UserVideos,
                // component: Dashboard,
            },

//****************************************************

//****************************************************
        ]
    },
    {
        path: '/login',
        name: "Login",
        meta: {
            requiresAuth: false,
        },
        component: Login,
        // component: Dashboard,
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
import axios from 'axios'
import UserVideos from "@/views/OtherData/UserVideos";
import Uploader from "@/views/OtherData/Uploader";
import NewsCategories from "@/views/news/NewsCategories.vue";
import AddNews from "@/views/news/AddNews.vue";
import NewsList from "@/views/news/NewsList.vue";
import BlogCategoryList from "@/views/blog/category/BlogCategoryList.vue";
import BlogAddNews from "@/views/blog/news/BlogAddNews.vue";
import BlogNewsList from "@/views/blog/news/BlogNewsList.vue";
import BlogCommentList from "@/views/blog/news/BlogCommentList.vue";
import Payments from "@/views/OtherData/Payments.vue";
router.beforeEach((to, from, next)=>{
    if ( to.meta.requiresAuth== true ){

        const formData = new FormData();
        var url = "check_auth";
        var config = {}
        config = {
            headers: {
                'Authorization': "Bearer "+localStorage.getItem("login_info")
            }
        }
        axios.post(url, formData, config).then(function (response) {
            if(response.data.error==1){
                next({
                    path: 'login',
                    replace: true
                })
            }else{
                next();
            }

        })
            .catch(function (error) {

                console.log(error);
            });

    } else {
        next();
    }
})
export default router
